var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-form px-4 mb-4"},[_c('form',{attrs:{"role":"form","method":"POST","action":_vm.url}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }